import { defineStore } from "pinia";

export const useAbsenceRequestStore = defineStore('absenceRequest', {
  state: () => ({
    absenceRequest: {},
    absenceRequests: [],
    loading: false,
  }),
  actions: {
    setLoading(state, loading) {
      state.loading = loading
    },
    setAbsenceRequest(absenceRequest) {
      this.absenceRequest = absenceRequest
    },
    setAbsenceRequests(absenceRequests) {
      this.absenceRequests = absenceRequests
    },
    addAbsenceRequest(absenceRequest) {
      this.absenceRequests.unshift(absenceRequest)
    },
    updateAbsenceRequest(absenceRequest) {
      let index = this.absenceRequests.findIndex(cl => cl.id === absenceRequest.id)
      this.absenceRequests.splice(index, 1, absenceRequest)
    },
    deleteAbsenceRequest(absenceRequest) {
      let index = this.absenceRequests.findIndex(cl => cl.id === absenceRequest.id)
      this.absenceRequests.splice(index, 1)
    },
  },
});